import {
    createSlice,
    createAsyncThunk,
    createEntityAdapter
} from '@reduxjs/toolkit'
import {
    envAwareFormSubmit,
    envAwarePost
} from '../util/util'


export const getExternalResources = createAsyncThunk(
    'getExternalResources',
    async () => await envAwarePost('api/externalResources/index/', {
        action: 'getExternalResources',
    })
)

export const createExternalResource = createAsyncThunk(
    'createExternalResource',
    async (payload) => await envAwarePost('api/externalResources/index/', {
        action: 'createExternalResource',
        ...payload
    })
)

export const editExternalResource = createAsyncThunk(
    'editExternalResource',
    async (payload) => {
        let { category_name, ...payloadToSend } = payload;

        return await envAwarePost('api/externalResources/index/', {
            action: 'editExternalResource',
            ...payloadToSend
        })
    }
)

export const removeExternalResource = createAsyncThunk(
    'removeExternalResource',
    async (payload) => await envAwarePost('api/externalResources/index/', {
        action: 'removeExternalResource',
        ...payload
    })
)

export const createExternalResourceCategory = createAsyncThunk(
    'createExternalResourceCategory',
    async (payload) => await envAwarePost('api/externalResources/index/', {
        action: 'createExternalResourceCategory',
        ...payload
    })
)

export const editExternalResourceCategory = createAsyncThunk(
    'editExternalResourceCategory',
    async (payload) => await envAwarePost('api/externalResources/index/', {
        action: 'editExternalResourceCategory',
        ...payload
    })
)

export const removeExternalResourceCategory = createAsyncThunk(
    'removeExternalResourceCategory',
    async (payload) => await envAwarePost('api/externalResources/index/', {
        action: 'removeExternalResourceCategory',
        ...payload
    })
)


const externalResourcesAdapter = createEntityAdapter()
const resourceCategoriesAdapter = createEntityAdapter();


const slice = createSlice({
    name: 'externalResources',
    initialState: {
        resources: externalResourcesAdapter.getInitialState(),
        resourceCategories: resourceCategoriesAdapter.getInitialState(),
        isLoading: false,
        categoryManager:{
            show:false
        }
    },

    reducers: {
        toggleCategoryManager: state => {
            state.categoryManager.show = !state.categoryManager.show
        }
    },

    extraReducers: {
        // get resource
        [getExternalResources.pending]: state => { state.isLoading = true },
        [getExternalResources.fulfilled]: (state, action) => {
            state.isLoading = false;
            const { data } = action.payload;

            externalResourcesAdapter.setAll(state.resources, data.external_resource)
            resourceCategoriesAdapter.setAll(state.resourceCategories, data.categories)

        },
        //remove resource
        [removeExternalResource.pending]: (state, action) => {
            let id = action.meta.arg.id;
            externalResourcesAdapter.removeOne(state.resources, id)

        },
        //edit resource
        [editExternalResource.pending]: (state, action) => {
            const { id, ...changes } = action.meta.arg
            externalResourcesAdapter.updateOne(state.resources, { id, changes })
        },
        //create resource
        [createExternalResource.fulfilled]: (state, action) => {
            const { success, data } = action.payload
            if (success === '1') externalResourcesAdapter.addOne(state.resources, data.external_resource)
        },

        //create category
        [createExternalResourceCategory.fulfilled]: (state, action) => {
            const { success, data } = action.payload
            if (success === '1') resourceCategoriesAdapter.addOne(state.resourceCategories, data.external_resource_category)
        },
        [editExternalResourceCategory.pending] : (state,action) => {
            const {id,update:changes} = action.meta.arg
            resourceCategoriesAdapter.updateOne(state.resourceCategories,{id,changes})
        },
        //remove category
        [removeExternalResourceCategory.pending]: (state, action) => {
            let id = action.meta.arg.id;

            let resourceEntities = Object.values(state.resources.entities)

            // remove deleted tag from all resources
            let updatedEntities = resourceEntities.map(item=>{
                return item.category_id == id ? 
                  {...item, category_id : 0, category_name : "none"} :
                    {...item}
                })

            resourceCategoriesAdapter.removeOne(state.resourceCategories, id);
            externalResourcesAdapter.setAll(state.resources, updatedEntities);
        },
    },
})

export const {toggleCategoryManager} = slice.actions

// Export the customized selectors for this adapter using `getSelectors`
export const {
    selectAll: selectAllExternalResources,
    selectById: selectExternalResourceById,
    selectIds: selectExternalResourcesById
} = externalResourcesAdapter.getSelectors(state => state.externalResources.resources)


// Export the customized selectors for this adapter using `getSelectors`
export const {
    selectAll: selectAllResourceCategories,
    selectById: selectResourceCategoryById,
    selectIds: selectAllResourceCategoryIds
} = resourceCategoriesAdapter.getSelectors(state => state.externalResources.resourceCategories)

export default slice.reducer